export const MuiFormGroupConfig = {
    styleOverrides: {
        root: ({ theme }: { theme: any }) => {
            return {
                marginBottom: theme.spacing(-1),
            };
        },
    },
};
